import axios from 'axios';
import { API_BASE_URL } from '../config/env';
import { USER_ROUTES } from '../constants/routeConstants';

/**
 * Centralized Axios instance for user-side API calls.
 * Uses cookie-based auth (withCredentials: true).
 */
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ─── Response Interceptor ────────────────────────────────────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';

    // 401 on auth/login endpoints is expected (failed credentials, not logged in, wrong password)
    // Never reload or redirect when calling auth endpoints or when already on the login page
    const isAuthEndpoint =
      url.includes('login') ||
      url.includes('register') ||
      url.includes('password') ||
      url.startsWith('/auth') ||
      url.includes('/auth/');

    const isAlreadyOnLoginPage =
      typeof window !== 'undefined' &&
      (window.location.pathname === USER_ROUTES.LOGIN ||
       window.location.pathname.startsWith('/login'));

    if (isAuthEndpoint || isAlreadyOnLoginPage) {
      return Promise.reject(error);
    }

    // Auto-redirect to login on 401 (session expired for authenticated users on protected pages)
    if (status === 401) {
      window.location.href = USER_ROUTES.LOGIN;
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
